import styled from "styled-components";
import { Input } from "antd";
const Search = Input.Search;

export const ComponentWrapper = styled.div`

`;


export const SearchInput = styled(Search)`
  height: 60px;
  @media (max-width: 991px) {
    height: 40px;
  }
  & input{
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    font-size: ${props => props.theme.fontSize.primary};
    border: 1px solid ${props => props.theme.border.pill} !important;
    border-radius: 0;
  }

  & input::placeholder {
    font-family: ${props => props.theme.fontFamily.helveticaNeue};
    color: ${props => props.theme.fontColors.placeholder};
    font-size: ${props => props.theme.fontSize.primary}; 
    @media (max-width: 991px) {
      font-size: ${props => props.theme.fontSize.tertiary};
    }
  } 
  & input::-moz-placeholder { /* Mozilla Firefox 4 to 18 */
    line-height: 50px !important;
  }
  .ant-input-suffix svg{
    width: 25px;
    height: 25px;
    color : #167f91;
    @media (max-width: 991px) {
      width:20px;
      height:20px;
    }
  }

  .ant-input-suffix {
    right: 30px;
    @media (max-width: 991px) {
     right :10px;
    }
  }
`;

export const ScrollContainer = styled.div``

export const ScrollUp = styled(ScrollContainer).attrs(()=>({
  className: "searchBarScrollUp"
  }))``

export const Box = styled.div`
  background-color: rgba(0, 103, 120, 0.15);
  position: relative;
  margin-top: 15px;
  padding: 20px 20px !important;
  bottom: 18px;
  box-shadow : 0px 10px 10px rgba(225, 225, 225, 0.5); 
  animation : slide-up 1s ease; 
  @keyframes slide-up {
    0% {
      opacity: 0;
      transform: translateY(-10px);
  }
  100% {
      opacity: 1;
      transform: translateY(0);
  }
  }
  &:after, &:before {
    bottom: 100%;
    left: ${props => props.left}%;
    border: solid transparent;
    content: " ";
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
      
    @media (max-width: 991px) {
      left: 57%;
    }
  }

  &:after {
    border-color: rgba(136, 183, 213, 0);
    border-bottom-color: rgba(0, 103, 120, 0.15);
    border-width: 10px;
    margin-left: -30px;
  }
  @media (max-width: 991px) {
    margin-top : 30px;
    padding: 20px 20px !important;
  }
`;